import React, { ReactElement } from 'react';

import EditorLayout from 'app/developer-v3/layouts/EditorLayout';
import { getTriggerUrl, isNewServiceField } from 'app/developer-v3/utils';

import type { AppDefinitionProps } from 'app/developer-v3/types';
import type { SemVer } from 'app/developer-v3/types/version';

type Props = AppDefinitionProps & {
  children: ReactElement;
  currentUrl: string;
  currentTriggerLabel: string;
  params: {
    id: string;
    version: SemVer;
    triggerKey: string;
  };
};

const TriggerEditor = ({
  children,
  currentTriggerLabel,
  currentUrl,
  params,
}: Props) => {
  const triggerUrl = getTriggerUrl(params);
  const isNewTrigger = isNewServiceField(params.triggerKey);
  const navItems = [
    { text: 'Settings', href: `${triggerUrl}/settings` },
    {
      text: 'Input Designer',
      href: `${triggerUrl}/input`,
      disabled: isNewTrigger,
    },
    {
      text: 'API Configuration',
      href: `${triggerUrl}/api`,
      disabled: isNewTrigger,
    },
  ];

  return (
    <EditorLayout
      currentUrl={currentUrl}
      navConfig={navItems}
      title={`${currentTriggerLabel} Trigger`}
    >
      {children}
    </EditorLayout>
  );
};

TriggerEditor.displayName = 'TriggerEditor';

export default TriggerEditor;
